import { Component } from '@angular/core';

import { DcSpinnerService } from '../../services';

@Component({
  selector: 'dc-spinner',
  styles: [ require('./spinner.component.scss') ],
  template: require('./spinner.component.html')
})
export class DcSpinner {
  spin = true;

  constructor(public spinnerService: DcSpinnerService) {
  }

  ngOnInit() {
    this.spinnerService.event.subscribe((event) => {
      this.spin = event;
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/directives/spinner/spinner.component.ts